import { render, staticRenderFns } from "./DocsFeedback.vue?vue&type=template&id=e029ac48&"
import script from "./DocsFeedback.vue?vue&type=script&lang=js&"
export * from "./DocsFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports